import { TreeSelect as $TreeSelect } from 'antd';
import { TreeSelectProps as $TreeSelectProps } from 'antd/lib/tree-select';
import { TreeNodeValue } from 'antd/lib/tree-select/interface';
import React from 'react';

import { OnBlurCallback, OnChangeCallback } from './index';

export type TreeSelectType = TreeNodeValue;

export type TreeSelectProps<T extends TreeNodeValue> = Omit<$TreeSelectProps<T>, 'onBlur' | 'onChange'> & {
  children?: React.ReactNode;
} & {
  name?: string;
  onBlur?: OnBlurCallback;
  onChange?: OnChangeCallback;
  onSelect?: OnChangeCallback;
};

/**
 * TreeSelect Component is for select dropdown with select hierarchy inside
 */
const TreeSelect = React.memo(function TreeSelect({
  name,
  treeData,
  onBlur,
  onChange,
  onSelect,
  dropdownMatchSelectWidth = true,
  treeDefaultExpandAll = true,
  size = 'large',
  dropdownStyle,
  ...rest
}: TreeSelectProps<TreeNodeValue>) {
  const handleBlur =
    onBlur &&
    ((value: any) => {
      onBlur({ name, value });
    });
  const handleChange =
    onChange &&
    ((value: any) => {
      onChange({ name, value });
    });
  const handleSelect =
    onSelect &&
    ((value: any) => {
      const data: any = value;
      onSelect({ name, value: data });
    });
  return (
    <$TreeSelect
      {...rest}
      size={size}
      treeData={treeData}
      dropdownMatchSelectWidth={dropdownMatchSelectWidth}
      onBlur={handleBlur}
      onChange={handleChange}
      onSelect={handleSelect}
      treeDefaultExpandAll={treeDefaultExpandAll}
      dropdownStyle={dropdownStyle}
    />
  );
});

export default TreeSelect;
